<template>
  <section>
    <p class="catch"><strong>安心・安全、快適、<br>そして環境にやさしいエスコート。<br>ユニットバス商品開発50年の集大成。</strong></p>
    <div class="is-tb">
      <div class="feature easy">
        <div><p class="title">Easy</p></div>
        <div>
          <p><strong>浴室サイズは変えずに洗い場ひろびろ</strong></p>
          <p>ゆったり入浴、ラクしてキレイの、使いやすい浴室へ</p>
        </div>
      </div>
    </div>
    <div class="thumb">
      <img src="/images/feature.png">
      <div class="btn"><app-button path="/concept" name="コンセプトを詳しくみる"/></div>

      <div class="is-pc">
        <div class="feature easy">
          <div><p class="title">Easy</p></div>
          <div>
            <p><strong>浴室サイズは変えずに洗い場ひろびろ</strong></p>
            <p>ゆったり入浴、ラクしてキレイの、使いやすい浴室へ</p>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="feature safety">
          <p class="title">Safety</p>
          <p><strong>すぐに暖まって<br>ずっとポカポカ</strong></p>
          <p>安心・安全を考え抜いた<br>家族を守る浴室へ</p>
        </div>
        <div class="feature eco">
          <p class="title">Eco</p>
          <p><strong>かしこくお風呂に入って<br>家計もぬくぬく</strong></p>
          <p>環境にも、家計にも<br>やさしいスマートな浴室へ</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppButton from '@/components/AppButton.vue'

export default {
  name: 'SlideFeature',
  components: {
    AppButton
  }
}
</script>

<style scoped lang="scss">
section {
  text-align: center;
  background: $colorBeige;
  padding: 5.46vh 0;

  @include mq(tb) {
    background: #fff;
    padding: 2.2vh 0;
  }
}

.catch {
  font-size: 16px;
  margin-bottom: 18.09vh;

  @include mq(tb) {
    font-size: 14px;
    line-height: 2;
    margin-bottom: 24px;
  }

  br {
    display: none;

    @include mq(tb) {
      display: block;
    }
  }
}

.wrap {
  @include mq(tb) {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }
}

.thumb {
  position: relative;
  display: inline-block;

  @include mq(tb) {
    margin-top: 24px;
  }

  .btn {
    width: $baseBtnSize;
    margin: -93px auto 0;

    @include mq(tb) {
      margin: -77px auto 0;
    }
  }

  img {
    width: 50%;

    @include mq(tb) {
      margin-bottom: 24px;
    }
  }
}

.feature {
  position: absolute;
  white-space: nowrap;

  @include mq(tb) {
    position: static;
  }

  &.easy {
    top: -11.68vh;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    display: flex;
    align-items: center;

    @include mq(tb) {
      justify-content: center;
      transform: none;
    }

    div {
      p + p {
        margin: 12px 0 0;

        @include mq(tb) {
          margin: 4px 0 0;
        }
      }

      + div {
        margin-left: 32px;

        @include mq(tb) {
          margin-top: -4px;
          margin-left: 16px;
        }
      }
    }
  }

  &.safety {
    bottom: 5.63vh;
    left: -1.71vw;
    text-align: right;

    @include mq(tb) {
      margin-left: 7.2vw;
      text-align: center;
    }
  }

  &.eco {
    bottom: 5.63vh;
    right: -3.7vw;
    text-align: left;

    @include mq(tb) {
      margin-right: 7.2vw;
      text-align: center;
    }
  }

  .title {
    font-size: 36px;
    font-family: $bellFont;
    margin-bottom: 16px;

    @include mq(tb) {
      font-size: 27px;
      margin-bottom: 0;
    }
  }

  p {
    font-size: 13px;
    line-height: 1.5;

    @include mq(tb) {
      font-size: 11px;
    }

    + p {
      margin-bottom: 12px;
    }

    strong {
      font-size: 15px;

      @include mq(tb) {
        font-size: 13px;
      }
    }
  }
}
</style>